import _tmpl from "./alert.html";
import { LightningElement, registerDecorators as _registerDecorators, registerComponent as _registerComponent } from "lwc";
import { c as classNames } from "ax/chunk_index";
let Variant = /*#__PURE__*/function (Variant) {
  Variant["Default"] = "default";
  return Variant;
}({});
let Theme = /*#__PURE__*/function (Theme) {
  Theme["Info"] = "info";
  Theme["Warning"] = "warning";
  Theme["Error"] = "error";
  return Theme;
}({});
class Alert extends LightningElement {
  constructor(...args) {
    super(...args);
    this.ariaLabel = null;
    this.ariaLive = null;
    this.variant = Variant.Default;
    this.theme = Theme.Info;
    this.alertTitle = null;
    this.alertMessage = void 0;
    this.alertAction = null;
    this.alertActionMessage = null;
  }
  get classes() {
    return classNames("element", {
      [`variant-${this.variant}`]: Object.values(Variant).includes(this.variant),
      [`theme-${this.theme}`]: Object.values(Theme).includes(this.theme)
    });
  }
  handleToastAction() {
    const alertActionEvent = new CustomEvent("alertaction", {
      bubbles: true
    });
    this.dispatchEvent(alertActionEvent);
  }
  handleToastClose() {
    const alertCloseEvent = new CustomEvent("close", {
      bubbles: true
    });
    this.dispatchEvent(alertCloseEvent);
  }
  /*LWC compiler v7.1.3*/
}
_registerDecorators(Alert, {
  publicProps: {
    ariaLabel: {
      config: 0
    },
    ariaLive: {
      config: 0
    },
    variant: {
      config: 0
    },
    theme: {
      config: 0
    },
    alertTitle: {
      config: 0
    },
    alertMessage: {
      config: 0
    },
    alertAction: {
      config: 0
    },
    alertActionMessage: {
      config: 0
    }
  }
});
const __lwc_component_class_internal = _registerComponent(Alert, {
  tmpl: _tmpl,
  sel: "ax-alert",
  apiVersion: 62
});
export default __lwc_component_class_internal;